export * from './TabComponent';
